import { Component } from '@angular/core';

import { LineType } from '../../models/annotation';
import { ITool } from '../../models/tool';
import { MouseModeService } from '../../services/mouse-state.service';

const LINE_TOOLS: ITool[] = [ {
    name: 'Line style: dashed',
    svgName: 'dashed-line',
    payload: LineType.DASHED
}, {
    name: 'Line style: dotted',
    svgName: 'dotted-line',
    payload: LineType.DOTTED
}, {
    name: 'Line style: solid',
    svgName: 'solid-line',
    payload: LineType.SOLID
} ];

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-line-tools',
    templateUrl: './tools.component.html',
    styleUrls: [ './annotations.component.scss' ]
})
export class LineToolsComponent  {
    tools = LINE_TOOLS;
    activeTool: ITool;

    constructor( private _mouseModeService: MouseModeService ) {
        this.activeTool = this.tools[0];
    }

    selectTool( tool: ITool ) {
        this.activeTool = tool;
        this._mouseModeService.setLineType( tool.payload as LineType );
    }
}
